import { jsx as h } from "react/jsx-runtime";
import { useIsLoggedIn as L } from "../hooks/useIsLoggedIn.js";
import { UnitHooks as x, SystemHooks as T, logout as U, AccountService as b, handleError as E } from "@propify-tenant-client/services";
import r from "lodash/noop";
import { createContext as P, useState as d, useCallback as u, useEffect as k } from "react";
import { useNavigate as B } from "react-router";
const l = {
  environment: "",
  personaTemplateId: "",
  googlePayMerchantId: "BCR2DN6TWPSO3VZC",
  paymentCycleDays: 60,
  showingsPerPaymentCycle: 15,
  dropboxSignConfiguration: {
    testMode: !1,
    skipDomainVerification: !1,
    locale: void 0,
    clientId: ""
  }
}, F = P({
  updateLogin: r,
  login: void 0,
  loadingLogin: !1,
  loadingRentedUnit: !1,
  rentedUnit: void 0,
  system: void 0,
  loadingSystemConfig: !1,
  accountBanned: !1,
  setAccountBanned: r,
  logout: r
}), H = ({ children: p }) => {
  const [t, i] = d(), [s, c] = d(!1), [v, g] = d(!1), m = B(), { isLoggedIn: n } = L(), { data: C, isFetching: y } = x.useRentedUnit({
    disabled: !n
  }), { data: e, isFetching: S } = T.useConfig({
    disabled: !n
  }), I = u(
    (o = "/user/login") => {
      U(), i(void 0), g(!1), m(o);
    },
    [m]
  ), f = u(async (o) => {
    if (o) {
      i(o);
      return;
    }
    try {
      c(!0);
      const a = await b.me();
      i(a);
    } catch (a) {
      E(a, {
        toastFallbackMessage: "There was an error fetching the account information"
      });
    } finally {
      c(!1);
    }
  }, []);
  return k(() => {
    n && !t && !s && f();
  }, [n, t, s]), /* @__PURE__ */ h(
    F.Provider,
    {
      value: {
        updateLogin: f,
        login: t,
        loadingLogin: s,
        rentedUnit: C?.[0],
        loadingRentedUnit: y,
        system: {
          ...l,
          environment: e?.environment ?? l.environment,
          personaTemplateId: e?.personaTemplateId ?? l.personaTemplateId,
          personaEnvironment: e?.personaEnvironment,
          dropboxSignConfiguration: e?.dropboxSignConfiguration
        },
        loadingSystemConfig: S,
        accountBanned: v,
        setAccountBanned: g,
        logout: I
      },
      children: p
    }
  );
};
export {
  F as SessionContext,
  H as SessionContextProvider
};
//# sourceMappingURL=SessionContext.js.map
